import { createApp } from 'vue';
import { createPinia } from 'pinia';
import ElementPlus from 'element-plus';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import 'element-plus/dist/index.css';
import '@sifusheng/ui-kit/brand.css';
import './styles/global.css';

import App from './App.vue';
import { router } from './router';
import { vPerm } from './directives/perm';

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.use(ElementPlus, { locale: zhCn });
app.directive('perm', vPerm);
app.mount('#app');
